export const releaseOrderLookupFieldDropdown =  [
	{
		title: "POS Location Number",
		value: "posLocation"
	},
	{
	  title: "VZW Order Number",
	  value: "vzOrderNumber"
	},
  {
    title: "SAP Delivery Number",
    value: "sapNumber"
  },
	{
	  title: "Order Type",
	  value: "type"
	},
	{
	  title: "Order Status",
	  value: "status"
	}
];



// WEBPACK FOOTER //
// ./src/pages/releaseOrders/filter/releaseOrderLookupFieldDropdown.js